import MobileMenu from './mobile_menu';

export default class MainMenu {
    initComponents() {
        this.components = {
            mobileMenu: MobileMenu,
        }
    }

    constructor() {
        this.initComponents();

        new this.components.mobileMenu();
        window.Global.resizeSensitiveFnc(() => {
            if(!this.mobileMenuInitialized) {
                if (window.innerWidth <= SBBreakpoints.LG) {
                    this.mobileMenuInitialized = new this.components.mobileMenu();
                }
            }
        });
    }

    //TODO: rework if needed
    highlightActiveItem() {
        const current_path = window.location.pathname;
        let result_item, result_path;
        document.querySelectorAll('.menu__list .menu__list-item').forEach(item => {
             let item_path = item.querySelector('a')?.getAttribute('href');
             if(current_path.includes(item_path) && (!result_path || item_path > result_path)) {
                 result_item = item;
                 result_path = item_path;
             }
        });
        if(result_item) {
            result_item.classList.add('menu__list-item--active');
        }
    }

}
